'use client'

import { ArrowLeft } from 'lucide-react'

export default function LegalBackButton() {
  return (
    <button
      type="button"
      onClick={() => {
        if (window.history.length > 1) {
          window.history.back()
          return
        }
        window.location.href = '/sign-in'
      }}
      className="inline-flex items-center gap-2 rounded-lg border border-white/15 px-3 py-2 text-sm font-semibold text-white/75 transition-colors hover:bg-white/10 hover:text-white"
    >
      <ArrowLeft className="h-4 w-4" />
      Back
    </button>
  )
}
